<template>
  <!-- Teleport 把弹窗内容渲染到 id 为 "teleport-target" 的 DOM 里，一般可在 index.html 中 body 下加 <div id="teleport-target"></div> -->
  <Teleport to="#teleport-target">
    <div
      class="mask-dialog"
      v-show="isShow"
    >
      <!-- 遮罩层，点击可关闭弹窗（可根据需求决定是否需要） -->
      <div
        class="mask-bg"
        @click="handleClose"
      ></div>
      <!-- 弹窗内容区域，这里模拟你的内容，可替换成实际的 App 引导等 -->
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>Get the app on the App Store</h3>
          <button
            class="close-btn"
            @click="handleClose"
          >×</button>
        </div>
        <div class="dialog-body">
          <div class="app-info">
            <img
              src=""
              alt="Suer Win Ph"
              class="app-icon"
            >
            <div>
              <p class="app-name">Suer Win Ph</p>
              <p class="app-url">Suer Win Ph.h21.com</p>
            </div>
          </div>
          <ol class="steps">
            <li>
              Tap on (share icon)
              <img
                src=""
                alt="share icon"
                class="share-icon"
              >
              in the browser bar.
            </li>
            <li>Scroll and select <span class="step-btn">Add to Home Screen</span>.</li>
            <li>Scroll and select
              <img
                src=""
                alt="add to home"
                class="add-home-icon"
              >
              Add to Home Screen.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue';

const isShow = ref(false);
const emit = defineEmits(['close']);

// 打开弹窗方法，外部调用控制显示
const openDialog = () => {
  isShow.value = true;
};

// 关闭弹窗
const handleClose = () => {
  isShow.value = false;
  emit('close');
};

// 暴露方法给父组件调用
defineExpose({
  openDialog
});
</script>

<style scoped>
.mask-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-end; /* 类似示例中弹窗在下方弹出，可根据需求调整位置 */
  z-index: 9999;
}

.mask-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明遮罩 */
}

.dialog-content {
  position: relative;
  width: 100%;
  max-width: 500px;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px;
  box-sizing: border-box;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.app-info {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.app-icon {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}

.app-name {
  font-weight: bold;
  margin-bottom: 4px;
}

.app-url {
  font-size: 12px;
  color: #999;
}

.steps {
  padding-left: 20px;
}

.steps li {
  margin-bottom: 8px;
}

.step-btn {
  background-color: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
}

.share-icon,
.add-home-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
</style>
